import { Component } from '@angular/core';
import { Modal } from '@shared/modal/models/modal.model';

export interface ConfirmModalParams {
  title: string;
  message: string;
  confirmType: ConfirmType;
  cancelButton: string;
  confirmButton: string;
  closeButton: boolean;
  hideCloseButton: boolean;
  choices?: Array<ConfirmModalChoice>;
}

export interface ConfirmModalChoice {
  value: string;
  label: string;
}

export enum ConfirmType {
  INFO,
  ERROR,
  WARNING
}

export enum Answer {
  TRUE,
  FALSE,
  CLOSE
}

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone: false
})
export class ConfirmModalComponent extends Modal {
  public confirmEnum = ConfirmType;
  public answerEnum = Answer;
  public params: ConfirmModalParams;
  public selectedChoice: string;

  onInjectInputs(params: ConfirmModalParams): void {
    this.params = params;
    this.selectedChoice = params.choices?.[0]?.value;
  }

  answer(result: Answer): void {
    this.close(result === Answer.TRUE && this.params.choices ? this.selectedChoice : result);
  }

  cancel(): void {
    this.close(false);
  }
}
